import type { FC } from "react";
import { Banner } from "@stubhub/broadway-web";
import { TrendOutlineIcon } from "@stubhub/broadway-web/icons/functional";
import { DemandDirection, type DemandTrendData } from "src/http/types";
import { FormatContent, useContent } from "src/shared/components/content";
import { demandTrendBannerRecipe, demandTrendBarRecipe } from "./demand-trend-banner.recipe";

interface Props {
  /** Model that contains both a `viewerCount`, and a `trendDirection` */
  demandTrendData: DemandTrendData;
}

const demandDirectionMap = {
  [DemandDirection.Low]: "low",
  [DemandDirection.Typical]: "typical",
  [DemandDirection.High]: "high",
} as const;

/**
 * DemandTrendBanner component displays a banner on the Performer page with demand trend information. The demand is
 * shown in a formatted string, with the trend direction, and also a visual demand bar, with a heat gradient where our
 * "success" colours represent low demand, and our "failure" colours represent high demand.
 */
export const DemandTrendBanner: FC<Props> = ({ demandTrendData }) => {
  const { viewerCount } = demandTrendData;
  /** "high" */
  const demandHigh = useContent("cid$#3916490#");
  const recipeParams = { demandDirection: demandDirectionMap[demandTrendData.demandDirection ?? DemandDirection.High] };
  const { bar, button } = demandTrendBarRecipe(recipeParams);
  return (
    <Banner icon={TrendOutlineIcon} classes={demandTrendBannerRecipe(recipeParams)}>
      {/* "Demand is <span class="content-demand">{0}</span>. {1} people viewed in the last hour." */}
      <FormatContent id="cid$#3916462#" params={[demandHigh, String(viewerCount ?? 0)]} raw />
      <div className={bar} aria-hidden role="presentation">
        <div className={button} />
      </div>
    </Banner>
  );
};
